// TIP-518 — Stay informed / Follow section.
// Copy locked verbatim. Right side is an illustrative "alerts inbox"
// product mockup (no live data).
import React from "react";

const TONE = {
  success: { color: "var(--success)", soft: "rgba(22,163,74,0.18)" },
  coral: { color: "var(--coral)", soft: "rgba(234,85,57,0.18)" },
  gold: { color: "var(--gold)", soft: "rgba(245,157,21,0.18)" },
};

const FollowAlert = ({ tone, biz, what, when }) => {
  const t = TONE[tone] || TONE.gold;
  return (
    <div className="follow-alert">
      <span className="follow-alert-dot" style={{ background: t.color, boxShadow: `0 0 0 4px ${t.soft}` }} />
      <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
        <span className="follow-alert-biz">{biz}</span>
        <span className="follow-alert-what">{what}</span>
      </div>
      <span className="follow-alert-when">{when}</span>
    </div>
  );
};

const FollowSection = () => (
  <section data-component="FollowSection" className="section-dark">
    <div className="container-wide">
      <div className="sec-eyebrow"><span className="sec-eyebrow-dot" />Stay informed</div>
      <h2 className="sec-title-dark">Follow businesses. Stay ahead of the changes.</h2>

      <div className="dark-split split-follow">
        <p className="dark-lead">
          Follow the businesses you sell to, buy from, or want to keep an eye on. When their licence, status, or contact details change on TREVEX, <b>you hear about it before it costs you a deal.</b>
        </p>

        <div className="follow-inbox" aria-hidden="true">
          <div className="follow-inbox-head">
            <div className="follow-inbox-title">Following · 14</div>
            <div className="follow-inbox-live">
              <span className="follow-inbox-live-dot" />
              <span className="follow-inbox-live-label">Live</span>
            </div>
          </div>
          <div className="follow-list">
            <FollowAlert tone="success" biz="Al Reem Industrial Supplies LLC"
              what={<><b>Trade licence renewed</b> for another year. Status active.</>} when="2h ago" />
            <FollowAlert tone="coral" biz="Madinat Trading Co."
              what={<><b>Registered address updated</b> from Dubai Investments Park to JLT.</>} when="Yesterday" />
            <FollowAlert tone="gold" biz="Falcon Logistics FZE"
              what={<><b>Earned Verified Member</b>. Documentary verification complete.</>} when="3d ago" />
          </div>
        </div>
      </div>
    </div>
  </section>
);

export default FollowSection;
